/*******************************************************************************
GET ALL TABS
Get the tab element, name and counter setting for every tab within a specific set of tabs.
*******************************************************************************/

export default function getAllTabs(tabSetName) {
    const $tabs = $(`.filter-tabs[data-name="${tabSetName}"]`);

    const tabs = [];
    $tabs.find('.filter-tab').each((index, tab) => {
        const $tab = $(tab);
        tabs.push({
            $element : $tab,                            // The tab element as a jQuery selector
            name     : $tab.data('name'),               // The name of the tab filter
            showCount: ($tab.data('count') === 'Yes'),  // [true/false] Should we show a count of matching items?
        });
    });

    return tabs;
}
